<template>
  <div>
    <form id="form" @submit.prevent="">
      <div class="form-group">
        <label>first pole</label>
        <div class="radio-inline">
          <label class="radio">
            <input type="radio" value="1" v-model="form.p1" />
            <span></span>
            روشن
          </label>
          <label class="radio">
            <input type="radio" value="0" v-model="form.p1" />
            <span></span>
            خاموش
          </label>
        </div>
      </div>
      <div class="form-group">
        <label>second pole</label>
        <div class="radio-inline">
          <label class="radio">
            <input type="radio" value="1" v-model="form.p2" />
            <span></span>
            روشن
          </label>
          <label class="radio">
            <input type="radio" value="0" v-model="form.p2" />
            <span></span>
            خاموش
          </label>
        </div>
        <span class="form-text text-muted">choose touch panel status</span>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "TP2",
  data() {
    return {
      form: {}
    };
  },
  computed: {
    ...mapGetters(["device"]),
    originalForm() {
      let status = this.device.status.toString();
      status = status === "" ? "00" : status;

      return {
        id: this.device.id,
        name: this.device.name,
        p1: status.charAt(0),
        p2: status.charAt(1)
      };
    }
  },
  beforeMount() {
    this.form = _.cloneDeep(this.originalForm);
  },
  watch: {
    form: {
      handler() {
        // if (_.isEqual(this.form, this.originalForm) === false) {
        this.$emit("change-form", this.form.p1 + this.form.p2);
        // }
      },
      deep: true
    }
  }
};
</script>
